import { getCbboApi, getFpoApi, userFpoListApi, cbboCRUDApiUrl, fpoCRUDApiUrl, userOrganizationApi } from "../constants/apis";
import axios from "axios";
import { getUserToken } from "../helpers/local_storage_helpers";

export const getCbbos = async (query) => {
    const config = {
        headers: {
            "Content-Type": "application/json",
            "Authorization": `Token ${getUserToken()}`,
        },
    };

    const response = await axios.get(getCbboApi + query ?? "", config);

    return response;
};

export const getFpos = async (query) => {
    const config = {
        headers: {
            "Content-Type": "application/json",
            "Authorization": `Token ${getUserToken()}`,
        },
    };

    const response = await axios.get(getFpoApi + query ?? "", config);

    return response;
};

export const getUsers = async (query) => {
    const config = {
        headers: {
            "Content-Type": "application/json",
            "Authorization": `Token ${getUserToken()}`,
        },
    };

    const response = await axios.get(userFpoListApi + query ?? "", config);

    return response;
};

export const postCbbo = async ({ data }) => {
    const config = {
        headers: {
            "Content-Type": "application/json",
            "Authorization": `Token ${getUserToken()}`,
        },
    };

    const response = await axios.post(cbboCRUDApiUrl, data, config);
    return response;
};

export const postUserOrganization = async ({ data }) => {
    const config = {
        headers: {
            "Content-Type": "application/json",
            "Authorization": `Token ${getUserToken()}`,
        },
    };

    const response = await axios.post(userOrganizationApi, data, config);
    return response;
};

export const patchUserOrganization = async ({ data, id }) => {
    const config = {
        headers: {
            "Content-Type": "application/json",
            "Authorization": `Token ${getUserToken()}`,
        },
    };

    const response = await axios.patch(userOrganizationApi + id + "/", data, config);
    return response;
};

export const patchCbbo = async ({ id, data }) => {
    const config = {
        headers: {
            "Content-Type": "application/json",
            "Authorization": `Token ${getUserToken()}`,
        },
    };

    const response = await axios.patch(cbboCRUDApiUrl + id + "/", data, config);
    return response;
};

export const postFpo = async ({ data }) => {
    const config = {
        headers: {
            "Content-Type": "application/json",
            "Authorization": `Token ${getUserToken()}`,
        },
    };

    const response = await axios.post(fpoCRUDApiUrl, data, config);
    return response;
};

export const patchFpo = async ({ id, data }) => {
    const config = {
        headers: {
            "Content-Type": "application/json",
            "Authorization": `Token ${getUserToken()}`,
        },
    };

    const response = await axios.patch(fpoCRUDApiUrl + id + "/", data, config);
    return response;
};

export const getFpoView = async ({ id }) => {
    const config = {
        headers: {
            "Content-Type": "application/json",
            "Authorization": `Token ${getUserToken()}`,
        },
    };

    const response = await axios.get(fpoCRUDApiUrl + id + "/", config);
    return response;
};